import React from 'react';
import { Chip } from '@material-ui/core';
import Theme from '/MuiTheme';

interface TabChipProps {
  label: string;
  selected: boolean;
  style?: object;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * displays a material ui style chip in secondary colors
 *
 * @param label:string, text to be displayed
 * @param selected:boolean, if the chip is activated
 * @param style:object, custom styling for chip
 * @param onClick:function, function if chip gets clicked
 * @param disabled:boolean
 */
const TabChip: React.FC<TabChipProps> = ({ label, selected, style, onClick, disabled }) => {
  const anyTheme = Theme as any; // workaround for typescript error with overlay not existing

  return (
    <Chip
      label={label}
      style={{
        color: anyTheme.palette.secondary.main,
        backgroundColor: `${anyTheme.palette.secondary.main}${
          selected ? anyTheme.palette.overlay.opacity.deactivated : anyTheme.palette.overlay.opacity.activated
        }`,
        border: selected ? `1px solid ${Theme.palette.secondary.main}` : '',
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default TabChip;
